export default function once(fn) {
    return function () {
        if (fn === null) return;
        var callFn = fn;
        fn = null;
        callFn.apply(this, arguments);
    };
}



// WEBPACK FOOTER //
// ../../../../~/async-es/internal/once.js